import { Link } from "react-router-dom";
import { Stethoscope, ArrowLeft } from "lucide-react";
import { LegalDisclaimer } from "./LegalDisclaimer";

export function LegalPage({ title, updated, children }) {
  return (
    <div className="flex min-h-screen flex-col bg-slate-50">
      <header className="sticky top-0 z-40 border-b border-slate-200 bg-white">
        <div className="mx-auto flex h-16 max-w-4xl items-center justify-between px-4 sm:px-6">
          <Link to="/" className="flex items-center gap-3">
            <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-blue-700 text-white">
              <Stethoscope className="h-5 w-5" />
            </div>
            <span className="font-heading text-lg font-800 text-slate-900">Agenda-ISF-COMO</span>
          </Link>
          <Link to="/" className="flex items-center gap-1.5 text-sm font-500 text-blue-700 hover:underline" data-testid="legal-back-home">
            <ArrowLeft className="h-4 w-4" /> Home
          </Link>
        </div>
      </header>
      <main className="mx-auto w-full max-w-4xl flex-1 px-4 py-12 sm:px-6">
        <article className="rounded-2xl border border-slate-200 bg-white p-8 sm:p-10">
          <h1 className="font-heading text-3xl font-800 text-slate-900">{title}</h1>
          <p className="mt-2 text-sm text-slate-400">Ultimo aggiornamento: {updated}</p>
          <div className="prose-legal mt-8 space-y-6 text-sm leading-relaxed text-slate-600">
            {children}
          </div>
        </article>
      </main>
      <LegalDisclaimer variant="footer" />
    </div>
  );
}

function Section({ n, title, children }) {
  return (
    <section>
      <h2 className="font-heading text-lg font-700 text-slate-900">{n}. {title}</h2>
      <div className="mt-2 space-y-2">{children}</div>
    </section>
  );
}

LegalPage.Section = Section;
